var exports = {
  "wx": "header__0VfPDR",
  "_": "rightSection__9ylBk0",
  "WZ": "previewBadge__sOASGN",
  "M0": "feedbackLink__qj24va",
  "h_": "description__fge1oG",
  "Un": "errorContainer__faOCqU",
  "Oe": "errorMarkdown__DaBs4u",
};

module.exports = exports;
